import { ShieldCheck } from "lucide-react";
import Reveal, { SectionHead } from "@/components/Reveal";
import PhoneMockup from "@/components/PhoneMockup";

export default function About() {
    return (
        <section id="about" className="scroll-mt-24 border-t border-white/5 py-20 sm:py-24 lg:py-28">
            <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-8 lg:grid-cols-[1.1fr_0.9fr] lg:gap-16 lg:px-12">
                <div>
                    <SectionHead
                        eyebrow="About"
                        title="Built to answer one question."
                        sub="Money comes in, money goes out — and it's surprisingly hard to say where it went. fynary. is an iOS & Android app that turns the statement CSVs you export into a clear monthly picture: spending, income, savings and trends."
                        testid="about-heading"
                    />
                    <Reveal delay={0.1}>
                        <p className="mt-5 max-w-xl text-base leading-relaxed text-fynary-muted sm:text-lg">
                            And when the numbers aren't enough, ask the assistant. fynary answers questions like “Which category spiked
                            compared to last month?” using only your own data.
                        </p>
                    </Reveal>

                    <Reveal delay={0.16}>
                        <div
                            data-testid="about-trust-card"
                            className="mt-8 rounded-[24px] border border-fynary-lime/25 bg-fynary-lime/5 p-6 sm:p-8"
                        >
                            <ShieldCheck className="h-6 w-6 text-fynary-lime" />
                            <p className="mt-4 font-display text-xl font-bold tracking-tight text-white sm:text-2xl">
                                fynary. never asks for bank passwords, PINs or OTPs.
                            </p>
                            <p className="mt-2 text-sm leading-relaxed text-fynary-muted sm:text-base">
                                No bank linking, no credential sharing. Your statement is imported by you and stays private to you.
                            </p>
                        </div>
                    </Reveal>
                </div>

                <Reveal delay={0.12} className="relative">
                    <div
                        aria-hidden="true"
                        className="pointer-events-none absolute left-1/2 top-1/2 h-[380px] w-[380px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-fynary-lime/[0.06] blur-[100px]"
                    />
                    <PhoneMockup screen="assistant" testid="about-phone-mockup" />
                </Reveal>
            </div>
        </section>
    );
}
